import { DEFAULT_QUERY } from 'components/context-menu-actions/add-query/query-rule-configs/default';
import { AllessehContentQueryBody } from 'hooks/useAllessehContentQuery';

export type QueryOptionCwsj = {
  query: AllessehContentQueryBody;
  label: string;
  type: null;
  url: string | null;
};

type QueryOptions = {
  [key: string]: QueryOptionCwsj[];
};

type QueryConfig = {
  [key: string]: QueryOptions;
};

export const QUERY_CONFIG_CWSJ: QueryConfig = {
  default: {
    default: [
      {
        query: {
          ...DEFAULT_QUERY,
          query: {
            and: [
              { term: { key: 'Product', value: 'WSJ S Chinese' } },
              { term: { key: 'LanguageCode', value: 'zh-cn' } }
            ]
          }
        },
        label: 'Custom Query',
        type: null,
        url: null
      }
    ]
  }
};
